import { Connector } from 'Webapp/utils/connector';
import {
  searchMentionables,
  fetchZeroStateMentionables,
} from 'Webapp/shared/concepts/mentionables';

const actions = {
  searchMentionables,
  fetchZeroStateMentionables,
};

export type ConnectMentionablesProps = Flipboard.ConnectorProps<
  unknown,
  typeof actions
>;

const connectMentionables: Connector = {
  actions,
};

export default connectMentionables;
